import React from 'react'

const SvgChatOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 18l-3-2H4V4h16v14zm2-2v6l-2-1.333L16 18H4a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v12zM8 11a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z'
    />
  </svg>
)

export default SvgChatOutline
